import {
	GET_ADMIN_PHASE_TRANSITIONS,
	FETCH_ADMIN_PHASE_TRANSITION,
	ADD_ADMIN_PHASE_TRANSITION,
	EDIT_ADMIN_PHASE_TRANSITION,
	DELETE_ADMIN_PHASE_TRANSITION,
} from "constants/actions";

const initialState = {
	phaseTransitions: [],
	pending: false,
};

export default function ActionPhaseTransition(state = initialState, action) {
	switch (action.type) {
		case GET_ADMIN_PHASE_TRANSITIONS:
			return {
				...state,
				phaseTransitions: action.payload,
				pending: false,
			};

		case FETCH_ADMIN_PHASE_TRANSITION:
			return {
				...state,
				[action.payload.id]: action.payload,
				pending: false,
			};

		case ADD_ADMIN_PHASE_TRANSITION:
		case EDIT_ADMIN_PHASE_TRANSITION:
			if (state.phaseTransitions && Array.isArray(state.phaseTransitions)) {
				const exists = state.phaseTransitions.find((p) => p.id === action.payload.id);
				const phaseTransitions = exists
					? state.phaseTransitions.map((p) => (p.id === action.payload.id ? action.payload : p))
					: [...state.phaseTransitions, action.payload];

				return {
					...state,
					phaseTransitions,
					[action.payload.id]: action.payload,
					pending: false,
				};
			}

			return {
				...state,
				[action.payload.id]: action.payload,
				pending: false,
			};

		case DELETE_ADMIN_PHASE_TRANSITION:
			return {
				...state,
				phaseTransitions: (state.phaseTransitions || []).filter((row) => row.id !== action.payload),
				pending: false,
			};

		default:
			return state;
	}
}

